import { getColourContrast } from './getColourContrast';

export const setCharityBrandingColours = (brandingTheme: string | null) => {
  if (!brandingTheme) return;

  const themeContrast = getColourContrast(brandingTheme);
  let backgroundColor = brandingTheme;
  let textColor = brandingTheme;
  let textOnBackgroundColor = '#ffffff';
  let backgroundBorderColor = brandingTheme;

  if (themeContrast && themeContrast > 175) {
    textColor = '#000000';
    textOnBackgroundColor = '#000000';
    backgroundBorderColor = '#cccccc';
  }

  document.documentElement.style.setProperty(
    '--theme-backgroundColor',
    backgroundColor,
  );
  document.documentElement.style.setProperty('--theme-textColor', textColor);
  document.documentElement.style.setProperty(
    '--theme-textOnBackgroundColor',
    textOnBackgroundColor,
  );
  document.documentElement.style.setProperty(
    '--theme-backgroundBorderColor',
    backgroundBorderColor,
  );
};
